import * as React from "react";
import { cn } from "@/lib/utils";

const buttonVariants = {
  variant: {
    default: "bg-primary text-contrast hover:bg-primary/90 font-medium",
    destructive:
      "bg-destructive text-destructive-foreground hover:bg-destructive/90 font-medium",
    outline:
      "border border-input bg-background hover:bg-accent hover:text-accent-foreground font-medium",
    secondary:
      "bg-secondary text-secondary-foreground hover:bg-secondary/80 font-medium",
    ghost: "hover:bg-accent hover:text-accent-foreground font-medium",
    link: "text-primary underline-offset-4 hover:underline font-medium",
  },
  size: {
    default: "h-10 px-4 py-2 gap-2",
    sm: "h-8 rounded-md px-3 text-xs gap-1.5",
    lg: "h-11 rounded-md px-8 gap-2",
    icon: "h-10 w-10",
  },
};

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof buttonVariants.variant;
  size?: keyof typeof buttonVariants.size;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "default", size = "default", ...props }, ref) => {
    return (
      <button
        className={cn(
          "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
          buttonVariants.variant[variant],
          buttonVariants.size[size],
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button };